import React from "react";
import { Icon } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";

const LineHeightMedium = () => (
  <Icon width={76} height={52}>
    <g
      stroke={cloud.getShade(5)}
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <path d="M9 45h58M9 36h58M9 27h58M9 18h58M9 9h58" />
    </g>
  </Icon>
);

export default LineHeightMedium;
